<template>
    <v-container class="example-drag ma-0 pa-0 mw-100">
        <v-container v-show="$refs.upload && $refs.upload.dropActive" class="drop-active ma-0 pa-0 mw-100">
            <h3>{{ $t('Headers.drag_and_drop_hover') }}</h3>
        </v-container>
        <v-container class="upload ma-0 pa-0 mw-100">
            <v-row>
                <v-col cols="12" class="text-center p-5">
                    <h4>{{ $t('Headers.drag_and_drop_text') }}<br />{{ $t('Headers.or') }}</h4>
                    <!--<label for="file" class="btn btn-lg btn-primary">{{ $t('Headers.drag_and_drop_button') }}</label>-->
                    <file-upload class="btn btn-primary" :style="cssProps" :multiple="multiple" :drop="true"
                        :drop-directory="false" v-model="files" ref="upload" extensions=".pdf" accept=".pdf">
                        <i class="fa fa-plus"></i>
                        {{ $t('Headers.drag_and_drop_button') }}
                    </file-upload>
                </v-col>
            </v-row>
        </v-container>
    </v-container>
</template>
<style>
.btn-primary {
    background-color: var(--primary-color) !important;
    border-color: var(--primary-color) !important;
    color: #fff !important;
    font-family: Roboto, sans-serif;
    font-weight: normal;
}

.example-drag h4 {
    font-family: Roboto, sans-serif;
    font-size: 24px;
    font-weight: normal;
}

.example-drag label.btn {
    margin-bottom: 0;
    margin-right: 1rem;
    color: #fff;
    font-family: Roboto, sans-serif;
    font-weight: normal;
}

.example-drag .drop-active {
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    position: fixed;
    z-index: 9999;
    opacity: .6;
    text-align: center;
    background: #000;
    font-family: Roboto, sans-serif;
    font-weight: normal;
}

.example-drag .drop-active h3 {
    margin: -.5em 0 0;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    font-size: 40px;
    color: #fff;
    padding: 0;
    font-family: Roboto, sans-serif;
    font-weight: normal;
}

.example-drag {
    border-bottom: 2px;
    border-top: 2px;
    border-left: 2px;
    border-right: 2px;
    border-style: dotted;
    border-color: lightgray;
}
</style>

<script>
import FileUpload from 'vue-upload-component'
export default {
    name: 'drag-and-drop',
    props: ['multiple'],
    components: {
        FileUpload,
    },
    computed: {
        cssProps() {
            return {
                '--primary-color': this.$vuetify.theme.themes.light.primary
            }
        }
    },
    data() {
        return {
            files: [],
        }
    },
    watch: {
        files: function (val, oldVal) {
            const isSameFile = (a, b) => a.name === b.name && a.name === b.name;

            const onlyInLeft = (left, right, compareFunction) =>
                left.filter(leftValue =>
                    !right.some(rightValue =>
                        compareFunction(leftValue, rightValue)));

            var result = onlyInLeft(val, oldVal, isSameFile);
            this.$emit('files', result)
        }
    }
}
</script>